import { SINGLE_API } from 'src/redux/actions/type';
import { GET_PDF, OPEN_PDF } from './type';

// export const MODEL_NAME = 'USER';
// export const MODEL_PLURAL = 'users';

export const getListCompanies = (payload = {}, next, nextErr) => {
	// const { filter, firstLoad } = payload;

	return {
		type: SINGLE_API,
		payload: {
			uri: '/companies',
			opt: {
				headers: {
					Accept: 'application/ld+json'
				}
			},
			params: payload,
			beforeCallType: 'GET_COMPANY_LIST_REQUEST',
			successType: 'GET_COMPANY_LIST_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};
export const getCompanieInfo = (payload = {}, next, nextErr) => {
	const { id } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: `/companies/${id}`,
			beforeCallType: 'GET_COMPANY_DETAIL_REQUEST',
			successType: 'GET_COMPANY_DETAIL_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const getSearchCompanieInfo = (payload = {}, next, nextErr) => {
	const searchString = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: `/companies/search?query=${searchString}`,
			beforeCallType: 'GET_COMPANY_SEARCH_REQUEST',
			successType: 'GET_COMPANY_SEARCH_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const getSearchListCompanieInfo = (payload = {}, next, nextErr) => {
	const { params } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: '/companies/search',
			opt: {
				headers: {
					Accept: 'application/ld+json'
				}
			},
			params,
			beforeCallType: 'GET_COMPANY_SEARCH_LIST_REQUEST',
			successType: 'GET_COMPANY_SEARCH_LIST_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const updateCompanieInfo = (payload = {}, next, nextErr) => {
	const { id } = payload;
	return {
		type: SINGLE_API,
		payload: {
			opt: { method: 'PUT' },
			uri: `/companies/${id}`,
			params: { ...payload },
			beforeCallType: 'UPDATE_COMPANY_LIST_REQUEST',
			successType: 'UPDATE_COMPANY_DETAIL_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const deleteCompany = (payload = {}, next, nextErr) => {
	const { id } = payload;
	return {
		type: SINGLE_API,
		payload: {
			opt: { method: 'DELETE' },
			uri: `/companies/${id}`,
			beforeCallType: 'GET_DELETE_COMPANY_REQUEST',
			successType: 'GET_DELETE_COMPANY_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const createCompany = (payload = {}, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			opt: { method: 'POST' },
			uri: '/companies',
			params: { ...payload },
			beforeCallType: 'CREATE_COMPANY_REQUEST',
			successType: 'CREATE_COMPANY_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const getCompanyTransaction = (payload, next, nextErr) => {
	// const { filter, firstLoad } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: `/companies/${payload.id}/transactions`,
			opt: {
				headers: {
					Accept: 'application/ld+json'
				}
			},
			params: payload,
			beforeCallType: 'GET_COMPANY_TRANSACTION_REQUEST',
			successType: 'GET_COMPANY_TRANSACTION_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const getAllAffectionHistory = (payload, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			uri: `/companies/affectation-history`,
			opt: {
				headers: {
					Accept: 'application/ld+json'
				}
			},
			params: payload,
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const getCompanySpent = (payload, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			uri: `/companies/get-company-spent`,
			opt: {
				headers: {
					Accept: 'application/ld+json'
				}
			},
			params: payload,
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const setCompanyInvoiceValidation = (payload, next, nextErr) => {
	const { id } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: `/company-invoice/set-payment-validation/${id}`,
			opt: {
				method: 'POST'
			},
			params: payload,
			afterSuccess: next,
			afterError: nextErr
		}

	};
};

export const getPdfCompanyInvoice = (payload, next, nextErr) => {
	const { id, fileName, type } = payload;
	return {
		type: (type == 'OPEN_PDF') ? OPEN_PDF : GET_PDF,
		payload: {
			opt: {
				method: 'GET',
			},
			uri: `/company-invoice-pdf/${id}`,
			params: payload,
			afterSuccess: next,
			afterError: nextErr
		}
	};
}

export const getBdcFile = (payload, next, nextErr) => {
	const { id, fileName, type } = payload;
	return {
		type: (type == 'OPEN_PDF') ? OPEN_PDF : GET_PDF,
		payload: {
			opt: {
				method: 'GET',
			},
			uri: `/company-invoice-bdc/${id}`,
			params: payload,
			afterSuccess: next,
			afterError: nextErr
		}
	};
}

export const getAffectToEmployeesFile = (payload, next, nextErr) => {
	const { id, fileName, type } = payload;
	return {
		type: GET_PDF,
		payload: {
			opt: {
				method: 'GET',
			},
			uri: `/company-invoice-affect-to-employees/${id}`,
			params: payload,
			afterSuccess: next,
			afterError: nextErr
		}
	};
}

export const getPdfTrustedPhoneNumberContract = (payload, next, nextErr) => {
	const { id, fileName, type } = payload;
	return {
		type: GET_PDF,
		payload: {
			opt: {
				method: 'GET',
			},
			uri: `/trusted-phone-number-contract/${id}`,
			params: payload,
			afterSuccess: next,
			afterError: nextErr
		}
	};
}

export const searchAffectionHistory = (payload, next, nextErr) => {
	const { search } = payload;
	return {
		type: SINGLE_API,
		payload: {
			opt: {
				method: 'GET',
			},
			uri: `/companies/search-affectation-history`,
			params: payload,
			afterSuccess: next,
			afterError: nextErr
		}
	};
}

export const getAffectionHistoryByCompany = (payload, next, nextErr) => {
	const { id } = payload;
	return {
		type: SINGLE_API,
		payload: {
			opt: {
				method: 'GET',
			},
			uri: `/companies/search-affectation-history-by-company`,
			params: payload,
			afterSuccess: next,
			afterError: nextErr
		}
	};
}

export const deleteCompanies = (payload = {}, next, nextErr) => { };

export const createCompanyAssociated = (payload = {}, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			opt: { method: 'POST' },
			uri: '/company/associated-account',
			params: { ...payload },
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const getListCompanyAssociated = (payload = {}, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			opt: { method: 'GET' },
			uri: '/company/get-associated-account',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const dissociatedCompany = (payload = {}, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			opt: { method: 'POST' },
			uri: '/dissociated-account',
			params: { ...payload },
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const attachBdcToInvoice = (payload, next, nextErr) => {

	const { invoice } = payload;

	return {
		type: SINGLE_API,
        payload: {
			opt: { method: 'POST' },
			params: payload,
			uri: `/attach_bdc/${invoice.id_invoice}`,
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const changeCompanyCreditInvoiceRefMonth = (payload, next, nextErr) => {

	const { invoice } = payload;

	return {
		type: SINGLE_API,
        payload: {
			opt: { method: 'POST' },
			params: payload,
			uri: `/change_ref_period/${invoice.id_invoice}`,
			afterSuccess: next,
			afterError: nextErr
		}
	};
};